/**
 * created by xcc
 * 宣传阵地管控公共action
 */

import request from "../../../base/request";

let serviceHost = '/cm-sites-media-consumer/';

const Apis = {
    getAllPositionTypeData: serviceHost + 'system/positionType/getAllNoPage', //获取全部平台类型数据
    getPositionTypeByDivision: serviceHost + 'position/management/getPositionTypeByDivision', //获取线上线下平台类型数据
    getActivityTypeData: serviceHost + 'system/activityType/list', //获取流程类型数据
    getActHistory: '/cm-sites-sys/process/getProcessHistory', //获取流程历史记录
    getMeHandleCount: serviceHost + 'position/management/getPositionNeedToDoInfo', //获取待我处理流程类型数量
};

export function getAllPositionTypeData(body, callBack, message) {
    request({url: Apis.getAllPositionTypeData, body, callBack, message: message});
}
export function getActivityTypeData(body, callBack, message) {
    request({url: Apis.getActivityTypeData, body, callBack, message: message});
}
export function getActHistory(body, callBack, message) {
    request({url: Apis.getActHistory, body, callBack, message: message});
}
export function getPositionTypeByDivision(body, callBack, message) {
    request({url: Apis.getPositionTypeByDivision, body, callBack, message: message});
}
export function getMeHandleCount(body, callBack, message) {
    request({url: Apis.getMeHandleCount, body, callBack, message: message});
}
